import React from 'react';
import PropTypes from 'prop-types';
import {
  VolumeButton,
} from './styles';

export default function NoSoundIcon({ onClick }) {
  return (
    <VolumeButton
      viewBox="0 -7 52 70"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g fill="white" fillRule="evenodd">
        <path
          d="M0.166748 19.6666V36.3333C0.166748 38.6249 2.04175 40.4999 4.33342 40.4999H16.8334L30.5418
          54.2083C33.1668 56.8333 37.6668 54.9583 37.6668 51.2499V4.70828C37.6668 0.999951 33.1668 -0.875049
          30.5418 1.74995L16.8334 15.4999H4.33342C2.04175 15.4999 0.166748 17.3749 0.166748 19.6666Z"
          stroke="white"
        />
      </g>
    </VolumeButton>
  );
}
NoSoundIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};
